import { createContext } from "react";
import { LocationLocale } from "../types/LocationLocale";

export const LocationLocaleContext = createContext<LocationLocale>(null!);
